import Commands from './commands/'
import Endpoints from './endpoints'
import News from './news'
import Messages from './messages'

var path =  require('@/assets/json/path.json')
var maps =  require('@/assets/json/maps.json')
const STATIC_FILES = process.env.BASE_URL || '/'

const State = {
    api: { 
        path: path.api
    },
    baseUrl: STATIC_FILES,
    backgroundImage: `${STATIC_FILES}images/back01-min.jpg`,
    carouselItems:[
        {src:`${STATIC_FILES}images/carousel/elf-min.png`, alt:'Elf', title:'MuOnline Elf'},
        {src:`${STATIC_FILES}images/carousel/knight-min.png`, alt:'Dark Wizard', title:'MuOnline Dark Knight'},
        {src:`${STATIC_FILES}images/carousel/wizard-min.png`, alt:'Dark Knight', title:'MuOnline Dark Wizard'},
        {src:`${STATIC_FILES}images/carousel/mg-min.png`, alt:'Magic Gladiator', title:'MuOnline Magic Gladiator'}
    ],
    vote: {
        topg: 'https://topg.org/topg.gif',
        tuservermu: `${STATIC_FILES}images/tsm-vote.gif`,
        arena: 'https://www.arena-top100.com/images/vote/mu-private-servers.png'
    },
    messages: Messages,
    loader: true,
    cookies: !!localStorage.getItem('accept-cookies'),
    page: {
        current: {
            name:'',
            number:0,
        },
        title: '',
        breadcrumb: [],
        menu: {
            expand: false
        }
    },
    maps:maps,
    modals: {
        online: false
    },
    dashboard: {
        page: 1,
        character: '',
        characterDirection: {
            left: [],
            right: []
        }
    },
    vip: {
        days:7
    },
    character: {
        breed: {
            char0:'Dark Wizard',
            char1:'Soul Master',
            char16:'Dark Knight',
            char17:'Blade Knight',
            char32:'Fairy Elf',
            char33:'Muse Elf',
            char48:'Magic Gladiator'
        },
        initial: {
            char0:'DW',
            char1:'SM',
            char16:'DK',
            char17:'BK',
            char32:'FE',
            char33:'ME',
            char48:'MG'
        }
    },
    server: {
        cs:false,
        gs:false
    },
    memberStatus: 0,
    shortRank: {
        guild:[],
        pker:[],
        player:[]
    },
    commands: Commands,
    endpoints: Endpoints,
    news: News,
    cost: {
        zenToCredits:1000000,
        creditsToZen:1,
        vip:10000,
        reset:{
            zen:10000000,
            credits:10
        },
        credits: {
            '3':10000,
            '5':20000,
            '10':50000
        }
    },
    reset: {
        level: {
            vip:400,
            normal:500
        }
    }
}

export default State;